module.exports = __webpack_public_path__ + "img/yakiton_banner.b9ef3b00.jpg";